/**
 * 从URL中提取查询参数并返回一个对象
 * @param url 要解析的URL字符串
 * @returns 包含查询参数的对象，如果URL无效则返回null
 */
export function getObjFromUrlParams(url: string): Record<string, string> | null | undefined {
  try {
    if (process.client) {
      // 尝试将传入的字符串解析为URL对象
      const urlObj = new URL(url)

      // 使用URL对象的search属性创建URLSearchParams对象
      const params = new URLSearchParams(urlObj.search)

      // 创建一个空对象用于存储参数键值对
      const result: Record<string, string> = {}

      // 遍历URLSearchParams对象，将每个参数的键和值存储到result对象中
      params.forEach((value, key) => {
        result[key] = value
      })

      // 返回包含参数的对象
      return result
    }
  } catch (e) {
    // 如果URL解析失败，捕获异常并输出错误信息
    console.error('Invalid URL', e)

    // 返回null表示解析失败
    return null
  }
}

// 创建cnzz入口
export function createCnzzJs(cnzz: string) {
  // const cnzz = 'https://s4.cnzz.com/z.js?id=1283333302,https://s4.cnzz.com/z.js?id=12833333023'
  if (!cnzz) return

  const cnzzList = cnzz.split(',').map(item => item.trim())
  cnzzList.forEach(item => {
    createJs(item)
  })
}


// 动态创建js
export function createJs(url: string) {
  if (process.client) {
    const urlObj = getObjFromUrlParams(url)
    const id = urlObj?.id || 'cnzzId'

    if (document.getElementById(id)) {
      return
    }

    const scriptObj = document.createElement('script')
    scriptObj.type = 'text/javascript'
    scriptObj.id = id
    scriptObj.src = url
    scriptObj.async = true
    scriptObj.defer = true

    // document.getElementsByTagName('head')[0].appendChild(scriptObj)
    const head = document.getElementsByTagName('head')?.[0]
    head.insertBefore(scriptObj, head?.firstChild)

    scriptObj.onload = () => {
      // console.log(`${id} script loaded successfully`)
    }
  }
}

// 创建51LA入口
export function create51LaJs(ids:string) {
  if (process.client) {
    ids = ids.replace(/\s+/g, '')
    if(!ids)return;
    const url = '//sdk.51.la/js-sdk-pro.min.js'
    const id =  'LA_COLLECT'
    const idList = ids.split(',')
    if (document.getElementById(id)) {
      return
    }

    const scriptObj = document.createElement('script')
    scriptObj.type = 'text/javascript'
    scriptObj.id = id
    scriptObj.src = url
    scriptObj.async = true
    scriptObj.defer = true

    document.getElementsByTagName('head')?.[0].appendChild(scriptObj)
    // const head = document.getElementsByTagName('head')?.[0]
    // head.insertBefore(scriptObj, head.firstChild)

    scriptObj.onload = () => {
      idList.forEach(id=>{
        id && window?.LA && window?.LA.init({ id: id, ck: id });
      })
    }
  }


}
